module.exports = __webpack_public_path__ + "static/media/left_label.0d8eb3c8.svg";